//* Libraries imports
import { z } from "zod";

export const tutorialItemSchema = z
  .object({ link: z.string().optional(), name: z.string().optional() })
  .optional();

export const tutorialSchema = z
  .object({
    text: tutorialItemSchema,
    video: tutorialItemSchema,
    audio: tutorialItemSchema,
    pdf: tutorialItemSchema,
  })
  .optional();
